'use client'

import * as React from 'react'
import { filterSearchInputClassName } from '@/components/shared/filterSheetStyles'
import { cn } from '@/lib/utils'

/** Matches filter pill typography; avoids shared Input's text-base / 16px defaults. */
export const filterSearchInputTypographyStyle: React.CSSProperties = {
  fontFamily: 'var(--font-family-primary)',
  fontSize: 'var(--font-size-filter-pill)',
  lineHeight: 'var(--line-height-filter-pill)',
  fontWeight: 'var(--font-weight-filter-pill)',
  letterSpacing: 'var(--letter-spacing-filter-pill)',
}

export const FilterSearchInput = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(function FilterSearchInput({ className, style, ...props }, ref) {
  return (
    <input
      ref={ref}
      className={cn('filter-search-input', filterSearchInputClassName, className)}
      style={{ ...filterSearchInputTypographyStyle, ...style }}
      {...props}
    />
  )
})
